import { render, staticRenderFns } from "./LockedMetricPanel.vue?vue&type=template&id=4d671a1a&scoped=true&"
import script from "./LockedMetricPanel.vue?vue&type=script&setup=true&lang=js&"
export * from "./LockedMetricPanel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LockedMetricPanel.vue?vue&type=style&index=0&id=4d671a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d671a1a",
  null
  
)

export default component.exports